import { IPv4PrefixesCountSubscription } from "../../graphql/generated/operations";

/**
 *
 * @param {IPv4PrefixesCountSubscription | undefined} data
 * @returns {number | undefined}
 */
export const formatter = (data) => data?.prefixesAggregate.aggregate?.count;
